import React from 'react';
import ReactDOM from 'react-dom';


ReactDOM.render(<div>
    You have reached this in error. please try another way.
</div>, document.getElementById('root'));